import { merge } from '../../helper';

import * as exTableContent from '../../content/table';
import * as exDatatableContent from '../../content/datatable';
import exDatatableManager from '../datatable/manager';
import * as exTreetableContent from '../../content/treetable';

// ----------------------------------------------------------------------------

function manager(element: HTMLElement, config: Record<string, any> = {}): Record<string, any> {
    // Manager DataTable
    const parent = exDatatableManager(element, config);

    // Source
    const src = parent.src;

    // ------------------------------------------------------------------------

    function init(): void {
        merge(src.config, config);

        //
        refresh();
    }

    // ------------------------------------------------------------------------

    function getTableWrapper(): HTMLElement {
        return parent.getTableWrapper();
    }

    function getTable(): HTMLElement {
        return parent.getTable();
    }

    function getElement(): HTMLElement {
        return parent.getElement();
    }

    // ------------------------------------------------------------------------

    const data = (function (): any {
        function get(): any[] {
            return parent.data.get();
        }

        function update(arr: any[]): void {
            parent.data.update(arr);
        }

        function restore(arr: any[]): void {
            parent.data.restore(arr);
        }

        // --------------------------------------------------------------------

        return {
            get,
            update,
            restore,
        };
    })();

    const rows = (function (): any {
        function get(id: number): Record<string, any> {
            return parent.rows.get(id);
        }

        function add(config: Record<string, any> = {}): void {
            // Operation Start
            exDatatableContent.operation.start(src.element, {
                merge: config,
                stripe: false,
            });

            // Foreach Data
            for (const item of config.data) {
                // Update Data
                parent.data.update(item);
            }
        }

        // --------------------------------------------------------------------

        return {
            get,
            add,
        };
    })();

    const ajax = (function (): any {
        function request(): void {
            parent.ajax.request();
        }

        function reload(): void {
            parent.ajax.reload();
        }

        // --------------------------------------------------------------------

        return {
            request,
            reload,
        };
    })();

    // ------------------------------------------------------------------------

    function refresh(): void {
        // Clear
        exTableContent.clear(src.element, src.config);

        // If there is data
        if ((src.data?.length ?? 0) > 0) {
            //
            src.config.data = src.data;

            // Operation Start
            exTreetableContent.operation.start(src.element, src.config);

            // Render
            render();
        }

        // Return
        /* return this; */
    }

    function render(): void {
        // Render Start
        exTreetableContent.render.start(src.element, src.config);

        // Return
        /* return this; */
    }

    function clear(): void {
        parent.clear();

        // Return
        /* return this; */
    }

    // ------------------------------------------------------------------------

    function resize(): void {
        parent.resize();

        // Return
        /* return this; */
    }

    // ------------------------------------------------------------------------

    init(); // Ready

    return {
        element,
        src,
        getTableWrapper,
        getTable,
        getElement,
        data,
        rows,
        ajax,
        refresh,
        render,
        clear,
        resize,
    };
}

// ----------------------------------------------------------------------------

export default manager;
